import PropTypes from 'prop-types';

import {
  articleShape,
  categoryShape,
  subcategoryShape,
} from 'components/InfoCenter/InfoCenter.config';

import PageHead from '../PageHead/PageHead';

/**
 * Head-related tags from a post's data.
 * Including Open Graph and Twitter markdown.
 *
 * @param {Object} props
 */
function PostHead({ post }) {
  return (
    <PageHead
      title={post.metaTitle ?? post.title}
      description={post.metaDescription}
      ogType="article"
      ogImageUrl={post.image?.url}
      ogImageType={post.image?.contentType}
      ogImageHeight={post.image?.height}
      ogImageWidth={post.image?.width}
    >
      {(post.category ?? post.subcategory) && (
        <meta
          property="article:section"
          content={post.category?.title ?? post.subcategory?.title}
        />
      )}

      <meta
        name="twitter:card"
        content={post.image ? 'summary_large_image' : 'summary'}
      />

      {post.image?.url && (
        <meta name="twitter:image" content={post.image.url} />
      )}
    </PageHead>
  );
}

PostHead.propTypes = {
  /** Info Center post */
  post: PropTypes.oneOfType([
    PropTypes.shape(articleShape),
    PropTypes.shape(subcategoryShape),
    PropTypes.shape(categoryShape),
  ]),
};

export default PostHead;
